import React from 'react';
import { Button, Radio, InputNumber } from 'antd';

/**
 * PrintControlPanel — maps FoxPro Pwtcmdp1 (customClass=pwtcmdp) container.
 *
 * FoxPro layout (top=260, 456x205):
 *   - OptGrp1 radio: 1=預覽 / 2=列印 (default 1)
 *   - Page range: PR_S_PAGE (start), PR_L_PAGE (end), defaults 1 / 99
 *   - PR_PAGE_SIZE display: "A4   直印" read-only
 *   - MSG1 textarea: progress/status messages
 *   - Command1 (印表機設定): SYS(1037) native dialog
 *   - Command3 (列印): confirm → U_PRINT → REPORT FORM PWM301P1
 *   - Command (離開): navigate away
 */

export type PrintMode = 1 | 2; // 1=預覽 2=直接列印

export interface PrintControlPanelProps {
  mode: PrintMode;
  onModeChange: (v: PrintMode) => void;
  startPage: number;
  endPage: number;
  onStartPageChange: (v: number) => void;
  onEndPageChange: (v: number) => void;
  message: string;
  busy: boolean;
  onPrint: () => void;
  onPrinterSetup: () => void;
  onExit: () => void;
}

const PrintControlPanel: React.FC<PrintControlPanelProps> = ({
  mode,
  onModeChange,
  startPage,
  endPage,
  onStartPageChange,
  onEndPageChange,
  message,
  busy,
  onPrint,
  onPrinterSetup,
  onExit,
}) => {
  return (
    <div className="m301-print-panel">
      <div className="panel-title">列印控制</div>

      <div className="panel-row">
        <span className="panel-label">列印模式:</span>
        <Radio.Group
          value={mode}
          onChange={(e) => onModeChange(e.target.value as PrintMode)}
          disabled={busy}
        >
          <Radio value={1}>預覽</Radio>
          <Radio value={2}>列印</Radio>
        </Radio.Group>
      </div>

      <div className="panel-row">
        <span className="panel-label">頁碼範圍:</span>
        <InputNumber
          min={1}
          max={999}
          value={startPage}
          onChange={(v) => onStartPageChange(typeof v === 'number' ? v : 1)}
          disabled={busy}
          style={{ width: 80 }}
        />
        <span className="panel-sep">~</span>
        <InputNumber
          min={1}
          max={999}
          value={endPage}
          onChange={(v) => onEndPageChange(typeof v === 'number' ? v : 99)}
          disabled={busy}
          style={{ width: 80 }}
        />
      </div>

      <div className="panel-row">
        <span className="panel-label">紙張設定:</span>
        <span className="panel-readonly">A4&nbsp;&nbsp;&nbsp;直印</span>
      </div>

      <div className="panel-row panel-msg-row">
        <span className="panel-label">狀態訊息:</span>
        <textarea
          className="panel-msg"
          value={message}
          readOnly
          rows={3}
          placeholder="列印狀態將顯示於此..."
        />
      </div>

      <div className="panel-row panel-actions">
        <Button type="primary" onClick={onPrint} loading={busy}>
          列印
        </Button>
        <Button onClick={onPrinterSetup} disabled={busy}>
          印表機設定
        </Button>
        <Button danger onClick={onExit} disabled={busy}>
          離開
        </Button>
      </div>
    </div>
  );
};

export default React.memo(PrintControlPanel);
